import PropTypes from "prop-types";
import SubmitButton from "components/SubmitButton";
import colors from "assets/theme/base/colors";

const VerifiedStatus = ({ data }) => {
  const { info } = colors;

  return (
    <>
      <SubmitButton
        background={data === 1 ? `${info.verified}` : `${info.secondary}`}
        hoverBackground={data === 1 ? `${info.verified}` : `${info.secondary}`}
        color="#fff"
        btnText={data === 1 ? "Verified" : "Not Verified"}
        type="button"
      >
        {data === 1 ? "Verified" : "Not Verified"}
      </SubmitButton>
    </>
  );
};

VerifiedStatus.propTypes = {
  tableNameProp: PropTypes.string,
  data: PropTypes.object.isRequired,
  access: PropTypes.bool.isRequired,
};

export default VerifiedStatus;
